import { clsx } from 'clsx';
import { useLanguage } from '../hooks/useLanguage';

interface StatsCardProps {
  label: string;
  value: string | number;
  subtext?: string;
  highlight?: boolean;
}

export function StatsCard({ label, value, subtext, highlight }: StatsCardProps) {
  return (
    <div
      className={clsx(
        'bg-tg rounded-xl p-4',
        highlight && 'ring-2 ring-brand-primary/20'
      )}
    >
      <div className="text-sm text-tg-hint mb-1">{label}</div>
      <div className={clsx('text-2xl font-bold', highlight ? 'text-brand-primary' : 'text-tg')}>
        {value}
      </div>
      {subtext && <div className="text-xs text-tg-hint mt-1">{subtext}</div>}
    </div>
  );
}

interface StatsGridProps {
  stats: {
    balance_usd: number;
    total_earned_usd: number;
    tasks_completed: number;
    pending_submissions: number;
    reputation_score: number;
    rank: number;
  };
}

export function StatsGrid({ stats }: StatsGridProps) {
  const { t } = useLanguage();

  return (
    <div className="grid grid-cols-2 gap-3">
      <StatsCard
        label={t('balance')}
        value={`$${(stats.balance_usd / 100).toFixed(2)}`}
        highlight
      />
      <StatsCard
        label={t('total_earned')}
        value={`$${(stats.total_earned_usd / 100).toFixed(2)}`}
      />
      <StatsCard
        label={t('completed')}
        value={stats.tasks_completed}
        subtext={t('tasks')}
      />
      <StatsCard
        label={t('pending')}
        value={stats.pending_submissions}
        subtext={t('reviews')}
      />
      <StatsCard
        label={t('reputation')}
        value={stats.reputation_score}
        subtext="/ 1000"
      />
      <StatsCard
        label={t('rank')}
        value={`#${stats.rank}`}
      />
    </div>
  );
}
